<template>
  <div class="personal-register-information">
    <div class="register-title">
      {{ $t("personal.Registration.information") }}
    </div>
    <div class="infor-box basic" :class="{ disabled: !show1, is_english: $i18n.locale === 'en' }">
      <div class="button" @click="show1 ? $router.push('guestInfo?step=' + STEP.BASE_INFO) : ''">
        {{
          show1
          ? edit1
            ? submit1
              ? $t("personal.Registration.edit")
              : $t("personal.Registration.filling")
            : $t("personal.Registration.view")
          : $t("personal.Registration.filling")
        }}
      </div>
    </div>
    <div class="infor-box intention" :class="{ disabled: !show2, is_english: $i18n.locale === 'en' }">
      <div class="button" @click="show2 ? $router.push('guestInfo?step=' + STEP.ATTEND) : ''">
        {{
          show2
          ? edit2
            ? submit2
              ? $t("personal.Registration.edit")
              : $t("personal.Registration.filling")
            : $t("personal.Registration.view")
          : $t("personal.Registration.filling")
        }}
      </div>
    </div>
    <div class="infor-box traffic" v-if="showNative" :class="{ disabled: !show3, is_english: $i18n.locale === 'en' }">
      <div class="button" @click="
        show3 ? $router.push('guestInfo?step=' + STEP.ARRIVE_LEAVE) : ''
        ">
        {{
          show3
          ? edit3
            ? submit3
              ? $t("personal.Registration.edit")
              : $t("personal.Registration.filling")
            : $t("personal.Registration.view")
          : $t("personal.Registration.filling")
        }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
const STEP = {
  BASE_INFO: "baseInfo",
  ATTEND: "attend",
  ARRIVE_LEAVE: "arriveLeave",
};
export default {
  name: "RegistInfo",
  data() {
    return {
      STEP,
    };
  },
  computed: {
    ...mapGetters([
      "show1",
      "show2",
      "show3",
      "edit1",
      "edit2",
      "edit3",
      "showNative",
      "submit1",
      "submit2",
      "submit3",
    ]),
  },
};
</script>

<style lang="scss" scoped>
.personal-register-information {
  position: relative;
  padding: 17px 0 0;

  &::before {
    content: "";
    position: absolute;
    top: 13px;
    left: 50%;
    transform: translateX(-50%);
    width: 135px;
    height: 18px;
    background: url("~@/assets/img/REGISTER_bg.png") center no-repeat;
    background-size: contain;
    z-index: 0;
  }

  .register-title {
    position: relative;
    font-size: 17px;
    font-family: SourceHanSansSC-Bold, SourceHanSansSC;
    font-weight: bold;
    color: #1debff;
    line-height: 25px;
    z-index: 1;
  }

  .infor-box {
    position: relative;
    width: 100%;
    height: 152px;
    margin: 0 0 8px;
    box-sizing: border-box;

    .button {
      position: absolute;
      left: 41px;
      bottom: 27px;
      min-width: 74px;
      padding: 4px 20px;
      box-sizing: border-box;
      background: rgba($color: #3eb134, $alpha: 0.79);
      border-radius: 16px;
      font-size: 15px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 21px;
      letter-spacing: 2px;
    }

    &.basic {
      background: url(~@/assets/img/basic_info_bg.png) no-repeat;
      background-size: contain;

      &.is_english {
        background: url(~@/assets/img/basic_info_bg_english.png) no-repeat;
        background-size: contain;
      }
    }

    &.intention {
      background: url(~@/assets/img/intention_info_bg.png) no-repeat;
      background-size: contain;

      &.is_english {
        background: url(~@/assets/img/intention_info_bg_english.png) no-repeat;
        background-size: contain;
      }
    }

    &.traffic {
      margin: 0 0 50px;
      background: url(~@/assets/img/traffic_info_bg.png) no-repeat;
      background-size: contain;

      &.is_english {
        background: url(~@/assets/img/traffic_info_bg_english.png) no-repeat;
        background-size: contain;
      }
    }

    &.disabled {
      .button {
        background: rgba($color: #5461cc, $alpha: 0.33);
        color: rgba($color: #fff, $alpha: 0.3);
      }
    }

    &.is_english {
      .button {
        left: 30px;
        bottom: 23px;
      }
    }
  }
}
</style>
